import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";
import {AUTH_TIPE} from "../constants/AuthConstant";

const operasionalBiayaLainnyaService = {}

operasionalBiayaLainnyaService.data = function (token, data = '') {
    return fetch({
        url: '/transaksi/operasional_biaya_lainnya/data',
        method: 'post',
        data: data,
        params: {},
        headers: {
            "x-api-key": X_API_KEY,
            "x-admin": localStorage.getItem(AUTH_TIPE)
        }
    })
}

operasionalBiayaLainnyaService.store = function (token, data) {
    return fetch({
        url: '/transaksi/operasional_biaya_lainnya/store',
        method: 'post',
        data: data,
        headers: {
            "x-api-key": X_API_KEY,
            "x-admin": localStorage.getItem(AUTH_TIPE)
        }
    })
}

operasionalBiayaLainnyaService.update = function (token, data) {
    return fetch({
        url: '/transaksi/operasional_biaya_lainnya/update',
        method: 'post',
        data: data,
        headers: {
            "x-api-key": X_API_KEY,
            "x-admin": localStorage.getItem(AUTH_TIPE)
        }
    })
}

operasionalBiayaLainnyaService.delete = function (token, data) {
    return fetch({
        url: '/transaksi/operasional_biaya_lainnya/delete',
        method: 'post',
        data: data,
        headers: {
            "x-api-key": X_API_KEY,
            "x-admin": localStorage.getItem(AUTH_TIPE)
        }
    })
}

export default operasionalBiayaLainnyaService;
